import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Add, Home } from "@mui/icons-material";
import CardTable from "../../components/CardTable/CardTable";
import { TableInputs } from "../../components/CardTable/TableInputs";
import RegularButton from "../../components/CustomButtons/Button";
import { ModalV2 } from "../../components/Modal/ModalV2";
import { COVERAGES_PHRASE } from "./config";
import { columns } from "./columns";
import { FormCoverageEdit } from './FormCoverageEdit';
import {
  fetchCoverages,
  addCoverageMode,
  deleteCoverage,
  handleCoveragesInputsAction
} from "../../redux/actions/coverages/coveragesActions";
import { useSearch } from "../../hooks/useSearch";

const tableKey = "coverages";

export const CoveragesPage = () => {
  const dispatch = useDispatch();
  const { setSnackbar, buildTableConfig } = useSearch();
  const { addMode, coverages, zoneTypeList, productTypeList, coverageSelected, station } = useSelector(state => state.coverages);
  const { isLoadingComp, configTables } = useSelector(state => state.search);
  const [openDelete, setOpenDelete] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const getCoverages = useCallback(
    stationID => {
      dispatch(fetchCoverages(stationID));
    },
    [dispatch]
  );

  const coveragesMemo = useMemo(
    () =>
      coverages.map(coverage => {
        return {
          ...coverage,
          typeName: zoneTypeList.find(obj => obj.value == coverage.type)?.label,
          productTypeName: productTypeList.find(obj => obj.value == coverage.product_type)?.label,
          modal: setOpenModal,
          deleteModal: setOpenDelete
        };
      }),
    [coverages]
  );

  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    if (!station?.id) {
      setSnackbar("Falta seleccionar planta");
      return;
    }
    getCoverages(station.id);
  }, [station, setSnackbar]);

  const handleDelete = () => {
    dispatch(deleteCoverage(coverageSelected.id, setOpenDelete));
  };

  const handleOpenAdd = () => {
    dispatch(addCoverageMode());
    setOpenModal(true);
  };

  useEffect(() => {
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, []);

  return (
    <React.Fragment>
      <CardTable
        data={coveragesMemo}
        columns={columns}
        loading={isLoadingComp?.fetchCoverages}
        title={COVERAGES_PHRASE.page.table.title}
        icon={<Home />}
        hasHeader
        blockBtn
        tableContent={
          <TableInputs
            reducer="coverages"
            stations
            dispatchAction={handleCoveragesInputsAction}
            submitAction={handleSubmit}
          />
        }
        tableKey={tableKey}
        hasControl
        controls={station?.id ?
          <RegularButton round justIcon color="info" onClick={handleOpenAdd}>
            <Add style={{ margin: 0 }} />
          </RegularButton>
          : null
        }
      />
      <ModalV2
        open={openModal}
        onClose={() => setOpenModal(false)}
        toRight
        halfScreen={addMode ? true : false}
        title={addMode ? 'Agregar nueva cobertura' : 'Editar cobertura'}
      >
        <FormCoverageEdit handleClose={() => setOpenModal(false)} id_station={station?.id} />
      </ModalV2>
      <ModalV2
        title={"¿Estas seguro de eliminar la cobertura?"}
        justConfirm
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        minHeight={2}
        textAlign="center"
        textMargin={28}
        onSubmit={handleDelete}
      />
    </React.Fragment>
  );
};
